import { render, staticRenderFns } from "./StudipDialog.vue?vue&type=template&id=3aa946e7&"
import script from "./StudipDialog.vue?vue&type=script&lang=js&"
export * from "./StudipDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aa946e7')) {
      api.createRecord('3aa946e7', component.options)
    } else {
      api.reload('3aa946e7', component.options)
    }
    module.hot.accept("./StudipDialog.vue?vue&type=template&id=3aa946e7&", function () {
      api.rerender('3aa946e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/StudipDialog.vue"
export default component.exports